<template>
  <card card-body-classes="table-full-width">
    <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <h4 slot="header" class="card-title">{{ $t('accountAssociations.pageAll.tableTitle') }}</h4>
      <span>
      </span>
    </div>
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
          class="select-primary mb-3 pagination-select"
          v-model="pagination.perPage"
          placeholder="Per page"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <div class="row">
          <div class="col-6">
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </base-input>
          </div>

        </div>
      </div>

      <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
        <el-table-column type="expand">
          <template slot-scope="props">
            <association-details :details="props.row"/>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
          :formatter="column.formatter"
        >
        </el-table-column>
        <el-table-column :label="$t('accountAssociations.details.account_id')">
          <div slot-scope="{ row }">
            <router-link :to="accountLinkUrl(row.account_id)">{{ row.account_id }}</router-link>
          </div>
        </el-table-column>
        <el-table-column :label="$t('accountAssociations.details.associated_account_id')">
          <div slot-scope="{ row }">
            <router-link :to="accountLinkUrl(row.associated_account_id)">{{ row.associated_account_id }}</router-link>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import {mapActions, mapState} from "vuex";
import AssociationDetails from "@/components/Associations/AssociationDetails";
import linkUtils from "@/util/link_utils";

export default {
  name: 'accountAssociations',
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    AssociationDetails
  },
  computed: {
    ...mapState({
      loading: state => state.account_associations.loading,
      data: state => state.account_associations.data,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
    // Table columns need to be computed to dynamically change the headers when language is selected
    tableColumns() {
      return [
        {
          prop: 'created_at',
          label: this.$t('generic.created'),
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          minWidth: 80,
        },
        {
          prop: 'type',
          label: this.$t('accountAssociations.details.type'),
          minWidth: 80
        },
      ]
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['type'],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    ...mapActions(['LoadAccountAssociations']),
    accountLinkUrl(id) {
      return linkUtils.accountProfileAssociationsPath(this.$router, {account_id: id});
    }
  },
  mounted() {
    this.LoadAccountAssociations(this.$route.params.id)
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    data(journeys) {
      this.tableData = journeys;
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    }
  }
};
</script>
